import React from 'react';
import { playButtonIcon } from './img/play_button_icon.js';
import Icon from '../icon/icon.js';
import classNames from '../../classnames.js';
import modules_547ff120 from './play_button.module.scss.js';

const PlayButton = ({ type = "default", onClick, loading = false }) => {
    const getPlayButtonContainerClassName = () => classNames(modules_547ff120[`play-button-${type}-container`], { [modules_547ff120["skeleton"]]: loading });
    const renderPlayButton = () => (React.createElement("div", { className: getPlayButtonContainerClassName(), onClick: onClick, "data-testid": "mbw-play-button-container" },
        React.createElement(Icon, { className: modules_547ff120[`play-button-${type}-icon`], dataTestId: "mbw-play-button-icon" }, playButtonIcon)));
    return renderPlayButton();
};

export { PlayButton as default };
//# sourceMappingURL=play_button.js.map
